import React, { useEffect } from 'react';
import config from '../../config.json';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import styled from 'styled-components';
import { Button, TextField, Autocomplete, Switch } from '@mui/material';
import { FilterInput } from '../../../shared/components/FilterInput';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogActions, Grid, DialogTitle } from '@mui/material';
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { deleteCustomer, getCompany, getRegion, getSites, siteApproveReject } from '../../api';


const TableWrapper = styled.div`
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
         background-color: #F59300 !important;
    }
   
    .materialTableStyle {
        table {
            border-collapse: separate;
            border-spacing: 0 1em;
            width: 99%;
            margin: auto;
        }
        th:first-child, td:first-child {
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
        }
        th:last-child, td:last-child {
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
        }
        th {
            font-size: 12px !important;
            white-space: nowrap;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            color: #F59300;
            height: 55px;
        }
        .MuiTableSortLabel-active {
            color: #F59300;
        }
        .MuiTableSortLabel-root:hover {
            color: #F59300;
        }
        .MuiTableSortLabel-icon {
            color: #F59300 !important;
        }
        td {
            position: relative;
            font-size: 12px !important;
            color: #000;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            height: 60px;
        }
        tbody {
            tr {
                position: relative;
                border-radius: 15px;
                transition: all 0.3s linear;
              
                &:hover {
                    box-shadow: 0 10px 6px rgba(0,0,0,0.10), 0 6px 3px rgba(0,0,0,0.10);

                    .actionListDeleteIconPosition {
                        display: block;
                    }
                    .actionListEditIconPosition {
                        display: block;
                    }
                    .actionListEmailIconPosition {
                        display: block;
                    }
                    .actionApproveIconPosition{
                        display: block;
                    }
                    .actionRejectIconPosition{
                        display: block;
                    }
                }
            }
        }
        .actionListDeleteIconPosition {
            position: absolute;
            top: -16px;
            right: 15px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionListEditIconPosition {
            position: absolute;
            top: -16px;
            right: 56px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionRejectIconPosition{
            position: absolute;
            top: -16px;
            right: 97px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionApproveIconPosition{
            position: absolute;
            top: -16px;
            right: 138px;
            display: none;
            transition: all 0.3s linear;
        }
       
        .actionBtn {
            padding: 8px;
            background-color: #ffffff;
            box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);

            &:hover {
                background-color: rgba(245,147,0,0.1);
                color: #F59300;
            }
        }
        .actionIcon {
            font-size: 17px;
        }
    }
    .filterRow {
        display: grid;
        grid-template-columns: 3fr 3fr 3fr 2fr 2fr;
        background-color: rgba(245, 147, 0, 0.1);
        height: 60px;
        border-radius: 15px;
        align-items: center;
        grid-column-gap: 10px;
        padding-left: 10px;
        padding-right: 10px;
        width: 99%;
        margin: auto;
    }
    .filterIconSize{
        font-size: 18px;
    }
    .filterDropdown {
        .MuiFilledInput-root {
            background-color: #ffffff;
            border-radius: 0;
        }
        .MuiFilledInput-input {
            padding: 5px 10px 5px;
            font-size: 12px;
        }
        .MuiFilledInput-underline:before {
            border: 0;
        }
        .MuiInputLabel-filled {
            transform: translate(12px,7px) scale(1);
            font-size: 12px;
        }
        .MuiFilledInput-underline:after {
            border: 0;
        }
        .MuiSelect-select:focus {
            background-color: #ffffff;
        }
        .MuiInputLabel-filled.MuiInputLabel-shrink {
            transform: translate(0px,-12px) scale(0.90) !important;
            color: #F59300;
        }
    }
    .filterAutocomplete{
    
        .closeIcon { 
            position: absolute;
            left: 450px;
            right: 0px;
            top: 20px;
            bottom: 0px;
        }
        .MuiFilledInput-root {
            background-color: #ffffff;
            border-radius: 0;
            height : 35px;
            padding-top : 0px;
        }
        .MuiFilledInput-input {
            padding: none;
            font-size: 12px;
            height : 10px;
        }
        .MuiFilledInput-underline:before {
            border: 0;
        }
        .MuiInputLabel-filled {
            transform: translate(12px,7px) scale(1);
            font-size: 12px;
        }
        .MuiFilledInput-underline:after {
            border: 0;
        }
        .MuiSelect-select:focus {
            background-color: #ffffff;
        }
        .MuiInputLabel-filled.MuiInputLabel-shrink {
            transform: translate(0px,-12px) scale(0.90) !important;
            color: #F59300;
        }}
`;

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


const headCells = [
    { id: 'company', numeric: false, label: 'Company' },
    { id: 'regionName', numeric: false, label: 'Region' },
    { id: 'area', numeric: false, label: 'Area' },
    { id: 'client', numeric: false, label: 'Site' },
    { id: 'city', numeric: false, label: 'City' },
    { id: 'state', numeric: false, label: 'State' },
    { id: 'adminContact', numeric: false, label: 'Admin' },
    { id: 'contact', numeric: false, label: 'Contact' },
    { id: 'isPaused', numeric: false, label: 'Status' },
    {}
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
};


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

export default function Customers() {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [message, setMessage] = React.useState(" ");
    var [rows, setRows] = React.useState([]);
    var [filteredRows, setFilteredRows] = React.useState([]);
    var [search, setSearch] = React.useState("");
    const token = config.TOKEN
    const navigate = useNavigate();
    var [deletePopup, setDeletePopup] = React.useState(false);
    var [recordId, setRecordId] = React.useState();
    const [deleteMessage, setDeleteMessage] = React.useState(" ");
    var [userEmail, setUserEmail] = React.useState("");
    var [userProfile, setUserProfile] = React.useState();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var [regionId, setRegionId] = React.useState(-1);
    var [clientId, setClientId] = React.useState(-1);
    var [regionList, setRegionList] = React.useState([]);
    var [clientList, setClientList] = React.useState([]);
    const [rejectedMessage, setRejectedMessage] = React.useState("");
    var [approvePopup, setApprovePopup] = React.useState(false);
    const [disable, setDisable] = React.useState(false);
    var [id, setId] = React.useState(0);
    var [status, setStatus] = React.useState("");
    const deleteMsg = () => toast("Customer deleted successfully!", { progressClassName: classes.customToastProgress });
    const approveMsg = () => toast("Site Approved Successfully!", { progressClassName: classes.customToastProgress });
    const rejectMsg = () => toast("Site Rejected Successfully!", { progressClassName: classes.customToastProgress });
    const errorMessage = () => toast("An error occured, try again later!", { progressClassName: classes.customToastProgress });

    useEffect(() => {

        userProfile = localStorage.getItem("userProfile");
        userProfile = JSON.parse(userProfile);
        setUserProfile(userProfile);
        userEmail = userProfile.userEmail;
        setUserEmail(userEmail);

        if (urlParams.get('clientId') && urlParams.get('regionId')) {
            clientId = parseInt(urlParams.get('clientId'));
            setClientId(clientId)
            fetchRegion(clientId);
            regionId = parseInt(urlParams.get('regionId'));
            setRegionId(regionId)
        }

        fetchCompany();
        if (userProfile.userType != "ClientUser") {
            fetchSites()
        }
    }, [])

    const fetchSites = async () => {
        try {
            const res = await getSites(userEmail, clientId, regionId);
            if (res.data.successCode === 0) {
                rows = res.data.data
                setRows(rows);
                filteredRows = rows;
                setFilteredRows(filteredRows)
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchCompany = async () => {
        try {
            const res = await getCompany(userEmail);
            if (res.data.successCode === 0) {
                clientList = res.data.data
                setClientList(clientList);
                if (userProfile.userType == "ClientUser") {
                    clientId = userProfile?.customerId;
                    setClientId(clientId)
                    clientList = clientList.filter(c => c.id == clientId)
                    setClientList(clientList)
                    fetchRegion(clientId);
                }
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }

    const updateCustomer = (id) => {
        navigate("/customer/edit/" + id)
    }
    const handleSearch = (event) => {
        search = event.target.value;
        setSearch(search);
        filteredRows = rows.filter(a => (a.client ? a.client.toLowerCase().includes(search.toLowerCase()) : a.client) || (a.company != null ? a.company.toLowerCase().includes(search.toLowerCase()) : a.company))
        setFilteredRows(filteredRows)

    }
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const handleDeleteCustomer = async (recordId, deleteFlag) => {
        try {
            const res = await deleteCustomer(recordId, deleteFlag);
            {
                if (res.data.successCode === 0) {
                    deleteMsg();
                    fetchSites()
                } else {
                    errorMessage();
                }
                setTimeout(() => { setDeletePopup(false) }, 3000);
            }
        } catch (error) {
            errorMessage();
            setTimeout(() => { setDeletePopup(false) }, 3000);
        }
    }

    const openDeletePopup = (id) => {
        recordId = id;
        setRecordId(recordId)
        deletePopup = true;
        setDeletePopup(deletePopup);
    }

    const fetchRegion = async (company) => {
        try {
            const res = await getRegion(company);
            if (res.data.successCode === 0) {
                regionList = res.data.data
                setRegionList(regionList)
                if (userProfile?.userType == "ClientUser" && userProfile?.regionId) {
                    regionId = userProfile?.regionId;
                    setRegionId(regionId)
                    regionList = regionList.filter(r => r.id == regionId)
                    setRegionList(regionList)
                }
                fetchSites();
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }

    const customHandleChange = (e, client) => {
        if (client != null) {
            clientId = client.id
            setClientId(clientId)
            fetchRegion(clientId)
        } else {
            clientId = -1
            setClientId(clientId)
        }
    };

    const openRejectPopup = (filteredRows, string) => {
        id = filteredRows.id
        setId(id)
        status = string
        setStatus(status)
        approvePopup = true;
        setApprovePopup(approvePopup);
    }

    const closeRejectPopup = () => {
        approvePopup = false;
        setApprovePopup(approvePopup);
    }

    const approveRejectSite = async (string) => {
        try {
            const res = await siteApproveReject(id, userEmail, status);
            if (res.data.successCode === 0) {
                if (status == "Approve") {
                    approveMsg();
                }
                else {
                    rejectMsg();
                    setTimeout(() => {
                        approvePopup = false;
                        setApprovePopup(approvePopup);
                    }, 5000)
                }
                fetchSites()
            } else {
                errorMessage();
            }
        } catch (error) {
            errorMessage();
        }
    }


    const approve = (filteredRows) => {
        if (userProfile?.userType == "Admin" && filteredRows?.approvalType == "ADDED") {
            return (
                <div>
                    <div className="actionApproveIconPosition">
                        <Tooltip title="Approve" aria-label="Approve">
                            <IconButton className="actionBtn" aria-label="Approve" onClick={() => openRejectPopup(filteredRows, "Approve")}>
                                <CheckIcon className="actionIcon" />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className="actionRejectIconPosition">
                        <Tooltip title="Reject" aria-label="Reject">
                            <IconButton className="actionBtn" aria-label="Reject" onClick={() => openRejectPopup(filteredRows, "Reject")}>
                                <ClearIcon className="actionIcon" />
                            </IconButton>
                        </Tooltip>
                        <Dialog open={approvePopup} closeonescape="true" maxWidth="sm" >
                            <TableWrapper>
                                <DialogTitle>
                                    <div className="text-right mb-2">
                                        <FontAwesomeIcon icon={faWindowClose} className="closeIcon" onClick={closeRejectPopup} />
                                    </div>
                                    {status == "Approve" ? "Do you want to Approve Site?" : "Do you want to Reject Site?"}
                                </DialogTitle>
                                <DialogContent className="dialogStyle">
                                    <DialogActions>
                                        <Grid container spacing={4}>
                                            <Grid item xs={12} sm={12} md={12} className="text-center">
                                                <Button type="submit" disabled={disable} variant="contained" color="primary" className="noShadow addBtn" onClick={() => approveRejectSite("Rejected")}>
                                                    Confirm
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </DialogActions>
                                </DialogContent>
                                {rejectedMessage}
                            </TableWrapper>
                        </Dialog>
                    </div>
                </div>
            )
        }
    }

    return (
        <TableWrapper>
            <ToastContainer theme="dark" />
            <Dialog open={deletePopup} closeonescape="true" maxWidth="true" >
                <TableWrapper>
                    <DialogContent className="dialogStyle">
                        <div className={`${classes.root} materialTableStyle`}>
                            Do you want to delete the record?
                        </div>
                        <DialogActions>
                            <Grid container spacing={4} className="mt-1">
                                <Grid item xs={12} sm={12} md={12} className="text-center">
                                    <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => setDeletePopup(false)}>
                                        No
                                    </Button>&nbsp;&nbsp;
                                    <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" onClick={() => handleDeleteCustomer(filteredRows.id, 1)}>
                                        Yes
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </DialogContent>
                </TableWrapper>
            </Dialog>
            <div className={`${classes.root} materialTableStyle`}>
                <div className="filterRow">
                    <FilterInput placeholder="Search" style={{ height: "35px" }} icon={<FilterListIcon className="filterIconSize" />} value={search} onChange={handleSearch} />

                    <Autocomplete
                        options={clientList}
                        className="filterAutocomplete"
                        getOptionLabel={(option) => option.name || ""}
                        value={clientList.find((option) => option.id === clientId) || null}
                        onChange={(e, client) => customHandleChange(e, client)}
                        // onChange={(event, client) => {
                        //     client != null ? setClientId(client.id) : setClientId(-1)
                        // }}
                        renderInput={(params) => <TextField  {...params} fullWidth label="Select Company" className="filter" variant="filled" />
                        }
                    />

                    <Autocomplete
                        options={regionList}
                        className="filterAutocomplete"
                        getOptionLabel={(option) => option.name || ""}
                        value={regionList.find((option) => option.id === regionId) || null}
                        onChange={(event, region) => {
                            region != null ? setRegionId(region.id) : setRegionId(-1)
                        }}
                        renderInput={(params) => <TextField  {...params} fullWidth label="Select Region" variant="filled" />
                        }
                    />

                    <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" onClick={() => fetchSites()} >
                        Search
                    </Button>

                    <Button variant="contained" color="primary" className="noShadow w-100 addBtn "
                        onClick={() => navigate("/customer/add")}
                    >
                        Add
                    </Button>
                </div>
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>

                            {stableSort(filteredRows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((filteredRows, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={filteredRows.id}
                                        >
                                            <TableCell>
                                                {filteredRows.customerName}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.regionName}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.area}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.client}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.city}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.state}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.adminContact}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.contact}
                                            </TableCell>
                                            <TableCell align="left">
                                                <Switch
                                                    checked={!filteredRows.isPaused}
                                                    name="status"
                                                    color="warning"
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    onClick={(event) => handleDeleteCustomer(filteredRows.id, 0)}
                                                />
                                            </TableCell>
                                            <TableCell align="left">
                                                <div className="actionListEditIconPosition">
                                                    <Tooltip title="Edit" aria-label="edit">
                                                        <IconButton className="actionBtn" aria-label="edit" onClick={() => { updateCustomer(filteredRows.id) }}>
                                                            <EditIcon className="actionIcon" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                                {userProfile?.userType != "ClientUser" && <div className="actionListDeleteIconPosition">
                                                    <Tooltip title="delete" aria-label="delete">
                                                        <IconButton className="actionBtn" aria-label="delete" onClick={() => { openDeletePopup(filteredRows.id) }}>
                                                            <DeleteIcon className="actionIcon" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>}
                                                {approve(filteredRows)}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    className="paginationLabel"
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={filteredRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </TableWrapper>
    );
}


